import { render, staticRenderFns } from "./EditableWysiwygText.vue?vue&type=template&id=6c571ee5&scoped=true"
import script from "./EditableWysiwygText.vue?vue&type=script&lang=js"
export * from "./EditableWysiwygText.vue?vue&type=script&lang=js"
import style0 from "./EditableWysiwygText.vue?vue&type=style&index=0&id=6c571ee5&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c571ee5",
  null
  
)

export default component.exports